import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const TerminateEmployeeTaskDefinition: TaskDefinition<'EmployeesEmployeeName'> = {
  taskableTypename: 'EmployeesEmployeeName',

  getUrl: ({ info, navigation }) => {
    const employeeId = info.id

    if (!employeeId) {
      return null
    }

    return navigation.employees.id.terminate.fullPath({
      id: String(employeeId),
    })
  },

  getTitle: ({ info }) => {
    const employeeName = info.fullName ?? null

    return i18n.t('employees.tasks.terminate.title_before', {
      name: employeeName,
    })
  },

  getMetadata: () => {
    return []
  },
}
